/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  'use strict';

  // Free shipping thresholds by country ISO code (GBP, whole pounds)
  // Zone 1: UK — £200
  // Zone 2: Europe / Africa — £300
  // Zone 3: USA, Mexico & Canada — £350
  // Zone 4: Oceania — £400
  // Zone 5: Rest of World — £500 (default)

  var THRESHOLDS = {
    // Zone 1
    GB: 200,

    // Zone 2 — Europe / Africa
    AX:300, AD:300, AL:300, DZ:300, AO:300, AT:300, BY:300, BE:300,
    BJ:300, BA:300, BW:300, IO:300, BF:300, BI:300, CV:300, CM:300,
    CF:300, TD:300, KM:300, CG:300, CD:300, HR:300, CY:300, CZ:300,
    DK:300, DJ:300, EG:300, GQ:300, ER:300, EE:300, SZ:300, ET:300,
    FI:300, FR:300, TF:300, GA:300, GM:300, GE:300, DE:300, GH:300,
    GI:300, GR:300, GG:300, GN:300, GW:300, VA:300, HU:300, IS:300,
    IE:300, IM:300, IT:300, JE:300, XK:300, LV:300, LS:300, LR:300,
    LY:300, LI:300, LT:300, LU:300, MG:300, MW:300, ML:300, MT:300,
    MR:300, MU:300, YT:300, MD:300, MC:300, ME:300, MA:300, MZ:300,
    NA:300, NE:300, NG:300, MK:300, NO:300, PL:300, PT:300, RE:300,
    RO:300, RU:300, RW:300, SH:300, BL:300, MF:300, PM:300, SM:300,
    ST:300, SN:300, RS:300, SK:300, SI:300, SO:300, ZA:300, SS:300,
    ES:300, SD:300, SE:300, CH:300, TZ:300, TG:300, TN:300, UG:300,
    UA:300, EH:300, ZM:300, ZW:300, SJ:300, TA:300, AC:300,

    // Zone 3 — USA, Mexico & Canada
    US:350, CA:350, MX:350,

    // Zone 4 — Oceania
    AU:400, NZ:400, CK:400, FJ:400, KI:400, NR:400, NU:400, PG:400,
    WS:400, SB:400, TO:400, TV:400, VU:400, CX:400, CC:400, NF:400,
    PN:400, TK:400, UM:400, PF:400, NC:400, WF:400, FK:400
  };

  var DEFAULT_THRESHOLD = 500; // Zone 5 — Rest of World

  function getThreshold(countryCode) {
    return THRESHOLDS.hasOwnProperty(countryCode)
      ? THRESHOLDS[countryCode]
      : DEFAULT_THRESHOLD;
  }

  function formatMoney(pence) {
    var format = (window.theme && window.theme.moneyFormat)
      || (window.Shopify && window.Shopify.money_format)
      || '\u00a3{{amount}}';
    var amount = (pence / 100).toFixed(2).replace(/\.00$/, '');
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(pence / 100))
      .replace('{{amount_with_comma_separator}}', amount)
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(pence / 100));
  }

  function applyState(cartTotalPence, thresholdPence, threshold) {
    var messageEl = document.querySelector('[data-cart-message]');
    if (!messageEl) return;

    var cartTotalGBP = cartTotalPence / 100;
    var remainingPence = thresholdPence - cartTotalPence;

    // Update progress wheel
    var progressEl = document.querySelector('[data-cart-progress]');
    if (progressEl) {
      var percent = Math.min(
        Math.round((cartTotalPence / thresholdPence) * 100),
        100
      );
      var circumference = 87.96459430051421;
      progressEl.style.strokeDashoffset =
        circumference - (percent / 100) * circumference;
      progressEl.setAttribute('data-percent', percent);
    }

    // Update remaining amount text
    var leftToSpendEl = document.querySelector('[data-left-to-spend]');
    if (leftToSpendEl && remainingPence > 0) {
      leftToSpendEl.textContent = formatMoney(remainingPence);
    }

    // Keep data-limit in sync with zone threshold
    messageEl.setAttribute('data-limit', threshold);

    // Toggle message state
    if (cartTotalGBP >= threshold) {
      messageEl.classList.remove('is-hidden');
      messageEl.classList.add('is-success');
    } else if (cartTotalPence > 0) {
      messageEl.classList.remove('is-hidden', 'is-success');
    } else {
      messageEl.classList.add('is-hidden');
      messageEl.classList.remove('is-success');
    }
  }

  function updateFreeShippingBar() {
  var country = window.adjoaaCountryCode || 'GB';
  var threshold = getThreshold(country);
  var thresholdPence = threshold * 100;
  var exchangeRate = window.adjoaaExchangeRate || 1;

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      // cart.total_price is in presentment currency minor units
      // Divide by exchange rate to get GBP pence
      var cartTotalPence = Math.round(cart.total_price / exchangeRate);
      applyState(cartTotalPence, thresholdPence, threshold);
    })
    .catch(function () {
      applyState(0, thresholdPence, threshold);
    });
}

  function init() {
    updateFreeShippingBar();

    // Watch cart drawer for DOM changes after AJAX updates
    var cartBody = document.querySelector('[data-cart-dropdown-body]');
    if (cartBody) {
      var debounceTimer;
      var observer = new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(updateFreeShippingBar, 300);
      });
      observer.observe(cartBody, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Also catch any named cart events the theme may fire
    ['cart:updated', 'cart:refresh', 'cart:change', 'theme:cart:updated'].forEach(
      function (evt) {
        document.addEventListener(evt, updateFreeShippingBar);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
